import React, {useContext} from 'react';
import {FormattedMessage} from 'react-intl';

import FilterBlock from "components/filter/FilterBlock";
import ToggleNavigation from "components/Toggle/ToggleNavigation";
import Toggle from "components/Toggle/Toggle";

import SelectedFilters from "./SelectedFilters";
import FilterElements from "./FilterElements";

import {OrderListContext} from "../../context/OrderListContext";

function FiltersMenu() {
    const {filterMenuSelected, setFilterMenuSelected, filters, selectedFilters, setSelectedFilters} = useContext(OrderListContext);

    function handleRemoveFilter(filter) {
        setSelectedFilters(selectedFilters.filter((selectedFilter) => selectedFilter.id !== filter.id));
    }

    return (
        <FilterBlock
            alreadyOpen
            activeFilterCount={selectedFilters.length}
            footer={selectedFilters.length > 0 && (
                <SelectedFilters
                    selectedFilters={selectedFilters}
                    onRemove={handleRemoveFilter}
                />
            )}
        >
            <ToggleNavigation
                value={Object.keys(filters).indexOf(filterMenuSelected)}
                onChange={(index) => setFilterMenuSelected(Object.keys(filters)[index])}
            >
                {Object.keys(filters).map((name) => (
                    <Toggle
                        key={name}
                        label={<FormattedMessage id={"retailer.product.list.filter." + name.toLowerCase()} />}
                    />
                ))}
            </ToggleNavigation>
            <FilterElements />
        </FilterBlock>
    );
}

export default FiltersMenu;
